import { isEmpty } from '@/utils/general/browserHelper'
import React from 'react'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'
import NearbyAirportFilter from './nearbyAirportFilter'

const selectedCount = (filter: any) =>
  (filter || []).reduce((total: number, { selectedValues }: any) => total + (selectedValues?.length || 0), 0)

const NearbyAirportNew = ({
  nearbyAirportFilter,
  returnNearbyAirportFilter,
  onFilterChange,
  isPerAdultPricing = true,
  isRT,
  processedData,
  clearFiltersCategoryWise,
  selectedFilters,
  isRevamp = false,
}: any) => {
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, 'nearbyAirportFilter')
  const count = selectedCount(nearbyAirportFilter) + selectedCount(returnNearbyAirportFilter)
  const showBothLegs = isRT && !isEmpty(returnNearbyAirportFilter?.[0]?.options)
  const shared = { isPerAdultPricing, isRT, isRevamp }

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Nearby airports' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(nearbyAirportFilter?.[0]?.options) && (
          <NearbyAirportFilter
            {...shared}
            nearbyAirportFilter={nearbyAirportFilter}
            onFilterChange={(type, values, index) => onFilterChange(type, values, index, 'onwardLeg')}
            from={processedData?.source}
            to={processedData?.destination}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />

        {showBothLegs && (
          <NearbyAirportFilter
            {...shared}
            nearbyAirportFilter={returnNearbyAirportFilter}
            onFilterChange={(type, values, index) => onFilterChange(type, values, index, 'returnLeg')}
            from={processedData?.destination}
            to={processedData?.source}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default NearbyAirportNew
